import type { ReactElement, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'
import { PageLoader } from '@/components/common/PageLoader'

interface RequireAuthProps {
  children: ReactNode
  /** Optional Entra ID app role required on top of being signed in. */
  role?: string
}

/** Route guard. Unauthenticated users are sent to /login with a return path. */
export function RequireAuth({ children, role }: RequireAuthProps): ReactElement {
  const { isAuthenticated, isReady, hasRole } = useAuth()
  const location = useLocation()

  if (!isReady) return <PageLoader />

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (role && !hasRole(role)) {
    return <Navigate to="/forbidden" replace />
  }

  return <>{children}</>
}
